window.addEventListener('DOMContentLoaded', function() {
  // disabled
  const submitButton = document.querySelector('form .resetButton')
  const emailInput = document.querySelector('input[name="email"]')
  if (emailInput) {
    // password_reset
    const resetForm = document.querySelector('.resetPasswordForm')
    if (resetForm) {
      resetForm.addEventListener('submit', function(event) {
        submitButton.setAttribute('disabled', 'disabled')
      })
    }

    // register
    const registerForm = document.getElementById('registerForm')
    if (registerForm) {
      registerForm.addEventListener('submit', function(event) {
        submitButton.setAttribute('disabled', 'disabled')
      })
    }

    if (submitButton.classList.contains('error')) {
      submitButton.removeAttribute('disabled')
    }
  }
})
